import { black1, grayDefault, grey10, grey9, white, yellow1 } from 'app/components/ThemeProvider/colors';
import { SxProps } from '@mui/material';
import { CSSProperties } from 'react';
import { getTheme } from '../ThemeProvider/theme';

const theme = getTheme('light');
export const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    background: '#F9FAFB',
    fontFamily: 'Yelo',
    color: black1,
    width: '210px',
    cursor: 'pointer',
    borderRadius: '8px',
    border: 'none',

    boxShadow: state.isFocused ? null : null,
    '&:hover': {
      borderColor: 'transparent',
    },
  }),

  container: (base: any) => ({
    ...base,
  }),
  menu: (base: any, state: any) => ({
    ...base,
    width: '285px',
    borderRadius: '8px',
    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
    marginTop: 0,
    padding: 0,
  }),
  menuList: (base: any) => ({
    ...base,

    padding: '16px 0',
    fontFamily: 'Yelo',
  }),

  valueContainer: (base: any, state: any) => ({
    ...base,
    // padding: 0,
    height: '48px',
    padding: '12px 16px',
    // margin: 0,
    background: 'transparent',
    fontWeight: state.getValue().length === 1 ? 500 : state.getValue() === 'All selected' ? 500 : 600,
  }),

  singleValue: (base: any) => ({
    ...base,
    margin: 0,
  }),

  multiValue: (base: any) => ({
    ...base,
    background: 'transparent',
    width: '100%',
    margin: 0,
  }),

  multiValueLabel: (base: any) => ({ ...base, padding: 0, paddingLeft: 0, fontSize: '16px', width: '96%' }),

  placeholder: (base: any) => ({
    ...base,
    padding: 0,
    margin: 0,
    fontWeight: 500,
  }),

  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    width: 0,
    height: 0,
  }),

  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),

  option: (base: any, state: any) => ({
    ...base,
    background: state.isSelected ? '#F3F4F6!important' : 'transparent',
    paddingLeft: '19px',
    color: black1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': { background: '#F3F4F6!important', cursor: 'pointer' },
  }),
};

export const customStylesWhiteBg = {
  control: (base: any, state: any) => ({
    ...base,
    background: grayDefault,
    fontFamily: 'Yelo',
    color: black1,
    width: '210px',
    cursor: 'pointer',
    borderRadius: '8px',
    border: 'none',

    boxShadow: state.isFocused ? null : null,
    '&:hover': {
      borderColor: 'transparent',
    },
  }),

  container: (base: any) => ({
    ...base,
  }),

  menu: (base: any, state: any) => ({
    ...base,
    width: '285px',
    borderRadius: '8px',
    boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
    marginTop: 0,
    padding: 0,
  }),

  menuList: (base: any) => ({
    ...base,

    padding: '16px 0',
    fontFamily: 'Yelo',
  }),

  valueContainer: (base: any, state: any) => ({
    ...base,
    // padding: 0,
    height: '48px',
    padding: '12px 16px',
    // margin: 0,
    background: 'transparent',
    fontWeight: state.getValue().length === 1 ? 500 : state.getValue() === 'All selected' ? 500 : 600,
  }),

  singleValue: (base: any) => ({
    ...base,
    margin: 0,
  }),

  multiValue: (base: any) => ({
    ...base,
    background: 'transparent',
    width: '100%',
    margin: 0,
  }),

  multiValueLabel: (base: any) => ({ ...base, padding: 0, paddingLeft: 0, fontSize: '16px', width: '96%' }),

  multiValueContainer: (base: any, state: any) => ({
    ...base,
    // padding: 0,
    height: '48px',
    padding: '12px 16px',
    // margin: 0,
    background: 'transparent',
    fontWeight: state.getValue().length === 1 ? 500 : state.getValue() === 'All selected' ? 500 : 600,
  }),

  placeholder: (base: any) => ({
    ...base,
    padding: 0,
    margin: 0,
    fontWeight: 500,
  }),

  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
    width: 0,
    height: 0,
  }),

  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),

  option: (base: any, state: any) => ({
    ...base,
    background: state.isSelected ? '#F3F4F6!important' : 'transparent',
    paddingLeft: '19px',
    color: black1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': { background: '#F3F4F6!important', cursor: 'pointer' },
  }),
};

export const lastOperationBox: SxProps = {
  background: white,
  borderRadius: '8px',
  width: '100%',
  boxShadow: '0px 0px 32px 0px rgba(0, 0, 0, 0.06)',
  pt: '28px',
  display: 'flex',
  flexDirection: 'column',
  gap: '28px',
};

export const btnStatusPayment: SxProps = {
  display: 'flex',
  gap: '8px',
  p: '6px 16px',
  background: 'transparent',
  [theme.breakpoints.down('sm')]: {
    p: '8px !important',
  },
};

export const btnSearch = (bg: boolean, searchInput: boolean) => {
  return {
    width: 'fit-content',
    height: '48px',
    minWidth: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: bg ? white : grey10,
    borderRadius: '8px',
    p: !searchInput ? '0px !important' : '0px 16px 0px 12px !important',
    gap: !searchInput ? '0px' : '8px',
    '&:hover': {
      background: bg && white,
    },

    '& .MuiSvgIcon-root': {
      width: '24px',
      height: '24px',
    },
  };
};
export const outlinedInput: SxProps = {
  height: '48px',
  background: 'transparent',
  width: '215px',
  p: '0px',
  '& fieldset': {
    border: 'none',
    background: 'transparent',
  },

  '& fieldset.MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
  },

  [theme.breakpoints.down(1400)]: {
    width: '146px',
  },
};

export const inputStyle: CSSProperties = {
  background: 'transparent',
  paddingLeft: '12px',
  fontSize: '16px',
  fontFamily: 'Yelo',
  color: black1,
  caretColor: 'rgba(20, 25, 31, 0.40)',
};

export const inputAdornment: SxProps = {
  display: 'flex',
  gap: '8px',
  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
    position: 'relative',
    right: '-16px',
  },

  '&:hover': {
    cursor: ' pointer',
  },
};

export const tableRowStyle: SxProps = {
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  p: '0 28px',
  gap: '30px',
};

export const tableCell: SxProps = {
  p: '21px 0',
  border: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
};

export const tableCellStatus: SxProps = {
  p: '21px 0',
  border: 'none',
  display: 'flex',
  gap: '15px',
  alignItems: 'center',
  width: '185px',
};

export const notif: SxProps = {
  background: yellow1,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  width: '20px',
  height: '20px',
};

export const notifText: SxProps = {
  fontSize: '12px',
  fontWeight: '700',
  fontFamily: 'Yelo',
};

export const menuItems: SxProps = {
  color: black1,
  display: 'flex',
  gap: '12px',
  fontSize: '15px',
  fontFamily: 'Yelo',
  p: '12px 16px',

  '&:hover': {
    color: `${black1} !important`,
    background: `${grey9} !important`,
  },
};

export const pagination: SxProps = {
  mt: '28px',
  position: 'relative',
  bottom: '-60px',
  '& .MuiPaginationItem-rounded, .MuiPaginationItem-previousNext': {
    borderRadius: '8px !important',
    width: '32px !important',
    height: '32px !important',
    background: 'white !important',
    borderColor: 'rgba(20, 25, 31, 0.10)',
    color: `${black1} !important`,
    fontWeight: '700 !important',
    fontFamily: 'Yelo',
  },

  '& ul li:first-of-type': {
    marginRight: '0',
  },

  '& ul li:last-of-type': {
    marginLeft: '0',
  },

  '& .Mui-disabled': {
    background: 'rgba(20, 25, 31, 0.10) !important',
  },

  '& .Mui-selected': {
    borderColor: black1,
  },
};

export const lastOperationsNone: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '16px',
  p: '0 24px',
  textAlign: 'center',
  height: '543px',
};
export const searchNone: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: grayDefault,
  p: '8px',
  borderRadius: '8px',
};
